import React from "react";
import { Box } from "@mui/material";

const ChatItemContainer = ({ children, onClick, selected, ...rest }) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      borderRadius="12px"
      px={2}
      py={0.8}
      sx={{
        cursor: "pointer",
        transition: "background-color 0.2s ease",
        "&:hover": {
          backgroundColor: "#f0f0f0",
        },
        ...(selected && {
          backgroundColor: "#e6e6e6",
        }),
      }}
      onClick={onClick}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default ChatItemContainer;
